module.exports = __webpack_public_path__ + "img/database-model.3f133f58.svg";